import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Placeholder from "react-bootstrap/Placeholder";

const MetricSkeleton = ({ count = 4 }) => {
  return (
    <Row className="g-4 mb-5">
      {Array.from({ length: count }).map((_, key) => (
        <Col lg={12 / count > 3 ? 3 : 12 / count} md={6} sm={12} key={key}>
          <Card style={{ borderRadius: '0px', border: '1px solid #edf2f9', backgroundColor: '#fff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.02)' }} className="h-100">
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div style={{ width: '100%' }}>
                  <Placeholder as="div" animation="glow">
                    <Placeholder xs={6} style={{ height: '14px', borderRadius: '0px', backgroundColor: '#f1f3f5' }} />
                  </Placeholder>
                  <Placeholder as="div" animation="glow" style={{ marginTop: '12px' }}>
                    <Placeholder xs={4} style={{ height: '36px', borderRadius: '0px', backgroundColor: '#f1f3f5' }} />
                  </Placeholder>
                </div>
                <Placeholder animation="glow">
                  <div style={{ width: '40px', height: '40px', borderRadius: '0px', backgroundColor: '#f1f3f5' }}></div>
                </Placeholder>
              </div>
              <Placeholder as="div" animation="glow" className="mt-2">
                <Placeholder xs={12} style={{ height: '12px', borderRadius: '0px', backgroundColor: '#f1f3f5', marginBottom: '4px' }} />
              </Placeholder>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

const DistributionSkeleton = () => {
  return (
    <Card style={{ borderRadius: '0px', border: '1px solid #edf2f9', backgroundColor: '#fff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.02)' }}>
      <Card.Body className="px-4 px-md-5">
        <Placeholder as="div" animation="glow" className="mb-2">
          <Placeholder xs={4} style={{ height: '22px', borderRadius: '0px', backgroundColor: '#f1f3f5' }} />
        </Placeholder>
        <Placeholder as="div" animation="glow" className="mb-5">
          <Placeholder xs={6} style={{ height: '14px', borderRadius: '0px', backgroundColor: '#f1f3f5' }} />
        </Placeholder>

        <div className="skeleton-gradient-bar"></div>

        <Row className="g-3">
          {[1, 2, 3, 4].map(k => (
            <Col key={k} lg={3} md={4} sm={6} xs={12}>
              <Placeholder animation="glow">
                <div style={{ height: '80px', borderRadius: '0px', backgroundColor: '#f1f3f5', width: '100%' }}></div>
              </Placeholder>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

const GraphSkeleton = () => {
  return (
    <div className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <Placeholder as="div" animation="glow">
            <Placeholder xs={4} style={{ height: '24px', borderRadius: '4px', backgroundColor: '#f1f3f5' }} />
          </Placeholder>
          <Placeholder as="div" animation="glow" className="mt-2">
            <Placeholder xs={6} style={{ height: '14px', borderRadius: '4px', backgroundColor: '#f1f3f5' }} />
          </Placeholder>
        </div>
        <div className="d-flex gap-2">
          {[1, 2, 3].map(k => (
            <div key={k} style={{ width: '60px', height: '32px', borderRadius: '4px', backgroundColor: '#f1f3f5' }}></div>
          ))}
        </div>
      </div>
      
      <Row className="g-4">
        <Col lg={8} md={12}>
          <Card style={{ borderRadius: '0px', border: '1px solid #edf2f9', backgroundColor: '#fff', padding: '24px' }}>
            <div className="mb-4">
              <div style={{ width: '200px', height: '24px', backgroundColor: '#f8f9fa', marginBottom: '8px' }}></div>
              <div style={{ width: '150px', height: '14px', backgroundColor: '#f8f9fa' }}></div>
            </div>
            <div style={{ height: '350px', backgroundColor: '#f8f9fa', borderRadius: '0px' }}></div>
            <div className="mt-4 pt-3" style={{ borderTop: '1px solid #f1f5f9' }}>
              <div style={{ width: '180px', height: '20px', backgroundColor: '#f8f9fa' }}></div>
            </div>
          </Card>
        </Col>
        <Col lg={4} md={12}>
          <Card style={{ borderRadius: '0px', border: '1px solid #edf2f9', backgroundColor: '#fff', padding: '24px' }}>
            <div className="d-flex align-items-center justify-content-center" style={{ height: '300px' }}>
              <div style={{ width: '180px', height: '180px', borderRadius: '50%', border: '25px solid #f8f9fa' }}></div>
            </div>
          </Card>
        </Col>
        <Col lg={12}>
          <Card style={{ borderRadius: '0px', border: '1px solid #edf2f9', backgroundColor: '#fff', padding: '24px' }}>
            <div style={{ height: '250px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}></div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export { MetricSkeleton, DistributionSkeleton, GraphSkeleton, ActivityMetricsSkeleton, TableSkeleton, ModalSkeleton };

const ModalSkeleton = () => {
  return (
    <div>
      <Row className="g-4 mb-5">
        {[1, 2, 3].map(i => (
          <Col key={i} md={4}>
            <div className="landlord-summary-card" style={{ border: '1px solid #eee' }}>
              <Placeholder as="div" animation="glow">
                <Placeholder xs={6} style={{ height: '12px', marginBottom: '12px', backgroundColor: '#f1f3f5' }} />
                <Placeholder xs={4} style={{ height: '28px', marginBottom: '8px', display: 'block', backgroundColor: '#f1f3f5' }} />
                <Placeholder xs={8} style={{ height: '10px', backgroundColor: '#f1f3f5' }} />
              </Placeholder>
            </div>
          </Col>
        ))}
      </Row>
      <div className="modal-filter-section mb-4">
        <Placeholder as="div" animation="glow">
          <Placeholder xs={3} style={{ height: '36px', borderRadius: '4px', backgroundColor: '#f1f3f5' }} />
        </Placeholder>
      </div>
      <div className="table-responsive">
        <table className="landlord-modal-table mb-0 table">
          <thead>
            <tr>
              {[1, 2, 3, 4, 5, 6].map(i => (
                <th key={i}>
                  <Placeholder as="div" animation="glow">
                    <Placeholder xs={6} style={{ height: '12px', backgroundColor: '#f1f3f5' }} />
                  </Placeholder>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map(i => (
              <tr key={i}>
                {[1, 2, 3, 4, 5, 6].map(j => (
                  <td key={j}>
                    <Placeholder as="div" animation="glow">
                      <Placeholder xs={8} style={{ height: '14px', backgroundColor: '#f8f9fa' }} />
                    </Placeholder>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ActivityMetricsSkeleton = () => {
  return (
    <div className="activity-metrics-wrapper mb-4">
      <div className="metrics-section">
        <Placeholder as="div" animation="glow" className="mb-3">
          <Placeholder xs={2} style={{ height: '14px', backgroundColor: '#e9ecef' }} />
        </Placeholder>
        <div className="metrics-cards-row-border">
          {[1, 2, 3].map((i) => (
            <div key={i} className="activity-metric-card" style={{ border: '1px solid #eee' }}>
              <Placeholder as="div" animation="glow">
                <Placeholder xs={8} style={{ height: '12px', marginBottom: '12px', backgroundColor: '#f1f3f5' }} />
                <Placeholder xs={4} style={{ height: '28px', marginBottom: '8px', display: 'block', backgroundColor: '#f1f3f5' }} />
                <Placeholder xs={10} style={{ height: '10px', backgroundColor: '#f1f3f5' }} />
              </Placeholder>
              <div className="mt-3" style={{ height: '4px', backgroundColor: '#f1f3f5', borderRadius: '2px', width: '80%' }}></div>
            </div>
          ))}
        </div>
      </div>

      <div className="metrics-section mt-5">
        <Placeholder as="div" animation="glow" className="mb-3">
          <Placeholder xs={2} style={{ height: '14px', backgroundColor: '#e9ecef' }} />
        </Placeholder>
        <div className="metrics-cards-row wrap-cards">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="activity-metric-card metric-card-filled" style={{ border: 'none', minWidth: '180px' }}>
              <Placeholder as="div" animation="glow">
                <Placeholder xs={9} style={{ height: '12px', marginBottom: '12px', backgroundColor: '#e9ecef' }} />
                <Placeholder xs={5} style={{ height: '28px', marginBottom: '8px', display: 'block', backgroundColor: '#e9ecef' }} />
                <Placeholder xs={7} style={{ height: '10px', backgroundColor: '#e9ecef' }} />
              </Placeholder>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const TableSkeleton = ({ rows = 5, cols = 6 }) => {
  return (
    <div className="tenants-card">
      <div className="p-4">
        <Placeholder as="div" animation="glow">
          <Placeholder xs={4} style={{ height: '14px', backgroundColor: '#f1f3f5' }} />
        </Placeholder>
      </div>
      <div className="table-responsive">
        <table className="tenants-table mb-0 table table-hover">
          <thead>
            <tr>
              {Array.from({ length: cols }).map((_, i) => (
                <th key={i}>
                  <Placeholder as="div" animation="glow">
                    <Placeholder xs={6} style={{ height: '12px', backgroundColor: '#f1f3f5' }} />
                  </Placeholder>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: cols }).map((_, j) => (
                  <td key={j}>
                    <Placeholder as="div" animation="glow">
                      <Placeholder xs={j === 0 ? 10 : 6} style={{ height: '14px', backgroundColor: '#f8f9fa' }} />
                      {j === 0 && <Placeholder xs={8} style={{ height: '10px', marginTop: '4px', display: 'block', backgroundColor: '#f8f9fa' }} />}
                    </Placeholder>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
